import has from 'lodash/has';

import {
  isKZContextPage,
  isLandingPage,
  isMonoAppRefPage,
  isSpecialRoutesPage,
  isWhiteLabelDeniedPage,
} from '@src/utils/routing';

import { getCRMSpecialHeaderText } from './getCRMSpecialHeaderText';

const SPECIAL_PAGE_HEADING = 'Займы онлайн от лучших МФО';
const KZ_CONTEXT_PAGE_HEADING = 'Займы в Казахстане';

export const getHeadingByRoute = (route: string, query: Record<string, string | string[]>) => {
  const isSpecial = isSpecialRoutesPage(route) || isWhiteLabelDeniedPage(route);
  const isCRMSpecial = isSpecial && has(query, 'landing_type');
  const isKZContext = isKZContextPage(route);
  const isMfoMonoRef = isMonoAppRefPage(route);
  const isLandigPage = isLandingPage(route);

  if (isLandigPage) {
    return {
      heading: 'Займы',
      subHeading: `Микрозайм онлайн — краткосрочный займ от МФО (микрофинансовой организации) на сумму до 100 000 ₽ без визита в офис. Ставка ограничена законом — не более 0,8% в день (292% годовых, ст. 12 Федерального закона № 151-ФЗ «О микрофинансовой деятельности и микрофинансовых организациях»). С 1 апреля 2026 суммарная переплата не может превысить 100% от суммы займа (данные Банка России, http://cbr.ru ). Займ через интернет подходит тем, кто решает короткий финансовый разрыв на 7–30 дней — особенно когда банк требует долгого ожидания`,
    };
  }

  if (isKZContext) {
    return { heading: KZ_CONTEXT_PAGE_HEADING, subHeading: '' };
  }

  if (isCRMSpecial) {
    return getCRMSpecialHeaderText(query?.landing_type as string);
  }

  if (isSpecial || isMfoMonoRef) {
    return {
      heading: SPECIAL_PAGE_HEADING,
      subHeading: '',
    };
  }
};
